// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__21gGL","content":"styles_content__3ggQF","selectAll":"styles_selectAll__3yci2"};